import store from "@/store/index.js";

export default [
  {
    path: "/stock/:id",
    name: "Stock",
    meta: { requiresAuth: true },
    component: () => import("@/views/Stock.vue"),
    beforeEnter: async (to, from, next) => {
      store.commit("inputValueOfStockSymbol", to.params.id);
      await store.dispatch("FETCH_LAYER");
      next();
    },
    children: [
      {
        path: "report-year",
        name: "report-year",
        meta: { requiresAuth: true },
        component: () => import("@/components/ReportYear/ReportYear.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("FETCH_REPORT_YEAR");
          next();
        }
      },
      {
        path: "report-quarter",
        name: "report-quarter",
        meta: { requiresAuth: true },
        component: () => import("@/components/Report/ReportQuarter.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("FETCH_REPORT_QUARTER");
          next();
        }
      },
      {
        path: "report-ratio-year",
        name: "report-ratio-year",
        meta: { requiresAuth: true },
        component: () =>
          import("@/components/ReportRatioYear/ReportRatioYear.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("FETCH_REPORT_RATIO_YEAR");
          next();
        }
      },
      {
        path: "report-ratio-quarter",
        name: "report-ratio-quarter",
        meta: { requiresAuth: true },
        component: () =>
          import("@/components/ReportRatio/ReportRatioQuarter.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("FETCH_REPORT_RATIO_QUARTER");
          next();
        }
      },
      {
        path: "chart-asset-year",
        name: "chart-asset-year",
        meta: { requiresAuth: true },
        component: () => import("@/components/ChartAsset/ChartAssetYear.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("FETCH_CHART_ASSET_YEAR");
          next();
        }
      },
      {
        path: "chart-asset-quarter",
        name: "chart-asset-quarter",
        meta: { requiresAuth: true },
        component: () =>
          import("@/components/ChartAsset/ChartAssetQuarter.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("FETCH_CHART_ASSET_QUARTER");
          next();
        }
      },
      {
        path: "chart-profit-year",
        name: "chart-profit-year",
        meta: { requiresAuth: true },
        component: () => import("@/components/ChartProfit/ChartProfitYear.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("FETCH_CHART_PROFIT_YEAR");
          next();
        }
      },
      {
        path: "chart-profit-quarter",
        name: "chart-profit-quarter",
        meta: { requiresAuth: true },
        component: () =>
          import("@/components/ChartProfit/ChartProfitQuarter.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("FETCH_CHART_PROFIT_QUARTER");
          next();
        }
      },
      {
        path: "news-all",
        name: "news-all",
        meta: { requiresAuth: true },
        component: () => import("@/components/News/NewsAll.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("fetchNewsAll", to.query.page);
          next();
        }
      },
      {
        path: "oneNews-create",
        name: "oneNews-create",
        meta: { requiresAuth: true },
        component: () => import("@/components/News/OneNewsCreate.vue")
      },
      {
        path: "oneNews-edit/:oneNewsId",
        name: "oneNews-edit",
        meta: { requiresAuth: true },
        component: () => import("@/components/News/OneNewsEdit.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("fetchOneNews", to.params.oneNewsId);
          next();
        }
      },
      {
        path: "oneNews-read/:oneNewsId",
        name: "oneNews-read",
        meta: { requiresAuth: true },
        component: () => import("@/components/News/OneNewsRead.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("fetchOneNews", to.params.oneNewsId);
          next();
        }
      },
      {
        path: "news-owner",
        name: "news-owner",
        meta: { requiresAuth: true },
        component: () => import("@/components/News/NewsOwner.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("fetchNewsOwner", to.query.page);
          next();
        }
      },
      {
        path: "survey-all",
        name: "survey-all",
        meta: { requiresAuth: true },
        component: () => import("@/components/Survey/SurveyAll.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("fetchSurveyAll", to.query.page);
          next();
        }
      },
      {
        path: "survey-owner",
        name: "survey-owner",
        meta: { requiresAuth: true },
        component: () => import("@/components/Survey/SurveyOwner.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("fetchSurveyOwner", to.query.page);
          next();
        }
      },
      {
        path: "oneSurvey-create",
        name: "oneSurvey-create",
        meta: { requiresAuth: true },
        component: () => import("@/components/Survey/OneSurveyCreate.vue")
      },
      {
        path: "oneSurvey-edit/:oneSurveyId",
        name: "oneSurvey-edit",
        meta: { requiresAuth: true },
        component: () => import("@/components/Survey/OneSurveyEdit.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("fetchOneSurvey", to.params.oneSurveyId);
          next();
        }
      },
      {
        path: "oneSurvey-read/:oneSurveyId",
        name: "oneSurvey-read",
        meta: { requiresAuth: true },
        component: () => import("@/components/Survey/OneSurveyRead.vue"),
        beforeEnter: async (to, from, next) => {
          await store.dispatch("fetchOneSurvey", to.params.oneSurveyId);
          next();
        }
      }
    ]
  }
];
